import AnimationText from './animation-text'

export default AnimationText;